module.exports = __webpack_public_path__ + "static/img/but.bfc41f06.png";